import React from 'react';
import { useWhyDidYouUpdate } from '../../hooks';
import { InputGroup, Col, FormControl } from 'react-bootstrap';
import { FlexRow } from './../index';
import { MdSearch } from 'react-icons/md';
//
//-------------------- Props -----------------------------------------------
//
type Props = {
  value: string;
  onChange: (string) => void;
};

//const Template: FC<Props> = props => {
const GridGlobalFilter = ({ value, onChange }: Props) => {
  useWhyDidYouUpdate('[GridGlobalFilter]', { value });
  return (
    <FlexRow>
      <div></div>
      <Col sm={6} md={4} lg={3} xl={2} className="px-0 mx-0">
        <InputGroup className="mb-2">
          <InputGroup.Text id="basic-addon1">
            <MdSearch size="1.5em"></MdSearch>
          </InputGroup.Text>
          <FormControl
            style={{ backgroundColor: 'lightYellow' }}
            value={value || ''}
            type="search"
            onChange={(e) => {
              onChange(e.target.value || undefined); // Set undefined to remove the filter entirely
            }}
            placeholder={`Αναζήτηση...`}
          />
        </InputGroup>
      </Col>
    </FlexRow>
  );
};

export default GridGlobalFilter;

